var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0892 15.9446C24.0892 20.423 20.4588 24.0535 15.9803 24.0535C11.5019 24.0535 7.87143 20.423 7.87143 15.9446C7.87143 11.4661 11.5019 7.83567 15.9803 7.83567C20.4588 7.83567 24.0892 11.4661 24.0892 15.9446Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 2.31623V1.30261M16.0001 30.6974V29.6838M29.6839 16H30.6975M1.30273 16H2.31635M25.6769 6.32423L26.3936 5.6075M5.60656 26.3926L6.32329 25.6759M25.6769 25.6758L26.3936 26.3925M5.60656 5.60742L6.32329 6.32416M24.0892 15.9446C24.0892 20.423 20.4588 24.0535 15.9803 24.0535C11.5019 24.0535 7.87142 20.423 7.87142 15.9446C7.87142 11.4661 11.5019 7.83567 15.9803 7.83567C20.4588 7.83567 24.0892 11.4661 24.0892 15.9446Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunon);
export default __webpack_public_path__ + "static/media/sunon.56b98376fe310fafc1542eaa5e347e7f.svg";
export { ForwardRef as ReactComponent };